import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-new-edit-location',
  templateUrl: './new-edit-location.component.html',
  styleUrls: ['./new-edit-location.component.scss']
})
export class NewEditLocationComponent implements OnInit {
  @ViewChild('mapContainer', { static: false }) mapContainer!: ElementRef;
  @ViewChild('autocomplete', { static: false }) autocomplete!: ElementRef;
  map!: google.maps.Map;
  marker!: google.maps.Marker;
  geocoder!: google.maps.Geocoder;
  apisub: Subscription
  constructor(private activemodal: MatDialogRef<NewEditLocationComponent>,@Inject(MAT_DIALOG_DATA) public parentdata:any, private loader: LoaderServiceService, private apiservice: ApiService) {
    this.apisub = this.apiservice.apiResult.subscribe(resdata =>{
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_UPDATE_ENTITY_LOCATION){
        if(resdata.result){
          this.loader.showLoader = false
          this.activemodal.close({msg: 'success'})
        }
      }
    })
   }

  ngOnInit(): void {
    setTimeout(() => {
      let address = {
        latitude: this.parentdata.data.lat,
        longitude: this.parentdata.data.lng
      }
      console.log(address);
      
      this.initializeMap(address)
      
    }, 1);
  }

  saveLocation(){
    let obj = {
      entity_hash: this.parentdata.entityHash,
      address_line : this.formattedAddress,
      city : (this.selectedLocation.city && this.selectedLocation.city != 'null') ? this.selectedLocation.city : 'null',
      state : (this.selectedLocation.state && this.selectedLocation.state != 'null') ? this.selectedLocation.state : 'null',
      country : (this.selectedLocation.country && this.selectedLocation.country != 'null') ? this.selectedLocation.country : 'null',
      pincode : (this.selectedLocation.zip && this.selectedLocation.zip != 'null') ? this.selectedLocation.zip : 'null',
      lat : (this.lat && this.lat != 'null') ? this.lat : 'null',
      lng : (this.lng && this.lng != 'null') ? this.lng : 'null' 
    }

    console.log(obj);

    this.loader.showLoader = true
    this.apiservice.updateEntityLocation(obj)

    
  }
    // -------------------- MAP THINGS ---------------------------
    lat:any
    lng:any
    initializeMap(address:any) {
      this.lat = address.latitude
      this.lng = address.longitude
      const mapOptions = {
        center: new google.maps.LatLng(address.latitude, address.longitude),
        zoom: 17,
      };
  
      this.map = new google.maps.Map(this.mapContainer.nativeElement, mapOptions);
  
      this.marker = new google.maps.Marker({
        map: this.map,
        draggable: true,
      });
  
      this.marker.setPosition(mapOptions.center);
      this.geocoder = new google.maps.Geocoder();
      const latLng = new google.maps.LatLng(address.latitude, address.longitude);
      this.geocodePosition(latLng);
  
      google.maps.event.addListener(this.marker, 'dragend', (event) => {
        this.geocodePosition(event.latLng);
      });
  
      const autocomplete = new google.maps.places.Autocomplete(this.autocomplete.nativeElement);
      autocomplete.bindTo('bounds', this.map);
  
      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        console.log(place);
        
        if (!place.geometry) {
          console.log("Autocomplete's returned place contains no geometry");
          return;
        }
  
        if (place.geometry.viewport) {
          this.map.fitBounds(place.geometry.viewport);
        } else {
          this.map.setCenter(place.geometry.location);
          this.map.setZoom(17);
        }
  
        this.marker.setPosition(place.geometry.location);
        this.storeLocation( place.address_components, place.formatted_address );
        const location = place.geometry.location;
            this.lat = location.lat().toFixed(6);
            this.lng = location.lng().toFixed(6);
      });
    }
    // this.storeLocation( results[ 0 ].address_components, results[ 0 ].formatted_address );
    geocodePosition(latLng: google.maps.LatLng) {
      console.log(latLng);
      
      this.geocoder.geocode({ location: latLng }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            console.log(results[0]);
            this.autocomplete.nativeElement.value = results[0].formatted_address;
            console.log('Address:', results[0].formatted_address);
            this.storeLocation( results[ 0 ].address_components, results[ 0 ].formatted_address );
            const location = results[0].geometry.location;
            this.lat = location.lat().toFixed(6);
            this.lng = location.lng().toFixed(6);
          } else {
            console.log('No results found');
          }
        } else {
          console.log('Geocoder failed due to:', status);
        }
      });
    }
  
    async getCurrentLocation(): Promise<any> {
      return new Promise(async (resolve, reject) => {
        if ('geolocation' in navigator) {
          navigator.geolocation.getCurrentPosition(
            async position => {
              const { latitude, longitude } = position.coords;
              try {
                resolve({ latitude, longitude});
              } catch (error) {
                reject('Error getting location info');
              }
            },
            error => reject(error)
          );
        } else {
          reject('Geolocation is not supported by your browser.');
        }
      });
    }
    selectedLocation : any = {};
    formattedAddress : any;
    storeLocation( location:any, formatted_address:any ) {
      
      const selectedLocation: any = {};
      location.forEach( (element:any) => {
          if ( element.types.includes( "postal_code" ) )
          {
              selectedLocation.zip = element.long_name
          } else if ( element.types.includes( "country" ) )
          {
              selectedLocation.country = element.long_name
          } else if ( element.types.includes( "administrative_area_level_1" ) )
          {
              selectedLocation.state = element.long_name
          } else if ( element.types.includes( "locality" ) )
          {
              selectedLocation.city = element.long_name
          } else if ( element.types.includes( "route" ) )
          {
              selectedLocation.address = element.long_name
          }
      } );
        this.formattedAddress = formatted_address;
        this.selectedLocation = selectedLocation;
    }
  

}
